import { useTheme } from '@mui/material/styles'
import { useEffect, useState, useContext, useRef } from 'react'
import { Stack, Box, Typography, List, ListItem } from '@mui/material'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import Logo from '../../assets/logo'
export const About = ({ }) => {
  const Navigate = useNavigate()

  const theme = useTheme()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <Stack sx={{ width: '100vw', minHeight: '100vh' }} alignItems={'center'}>
      <Stack
        sx={{ width: '100vw', height: 200 }}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Logo width={200} />
      </Stack>

      <Stack
        direction={'column'}
        sx={{ maxWidth: 600, justifyContent: 'center' }}
        style={{ fontSize: 22, marginBottom: 16 }}
      >
        <motion.div style={{ fontSize: 16, fontWeight: 300, marginBottom: 20 }}>
          Welcome to JoinU for the Harvard community
        </motion.div>
        <motion.div style={{ fontSize: 25, fontWeight: 500, marginBottom: 5 }}>
          About JoinU for the Harvard community
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 5 }}>
        JoinU is an innovative platform that simplifies how university affiliates discover and engage in campus events, fostering a vibrant local community brimming with opportunities. Each participating university, including Harvard, has its own tailored platform. JoinU for the Harvard community is specifically designed for and managed by members of the Harvard community, empowering individuals to:
        </motion.div>
        <List
          sx={{
            listStyleType: 'decimal',
            pl: 2,
            '& .MuiListItem-root': {
              display: 'list-item',
              pt: 0,
              pb: 0,
              pr: 0,
            },
          }}
        >
          {[
            'Connect: Establish meaningful connections with others.',
            'Explore: Discover new interests and expand your horizons.',
            'Create: Contribute to a lively and dynamic university community.',
          ].map((d, i) => (
            <ListItem style={{ fontSize: 18, marginBottom: 5 }}>{d}</ListItem>
          ))}
        </List>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
        JoinU is developed, maintained, and operated by professional developers at the Public Interest Tech Lab. Each version of the app is uniquely customized and managed by students at their respective universities. This tailored approach ensures that JoinU is a versatile and scalable platform, making it ideal for adoption across a wide range of educational institutions and organizations.
        </motion.div>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 5, marginTop: 30 }}>
          Why JoinU Stands Out
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
          JoinU is distinguished not only by its ability to connect users and build community, but also by its commitment to privacy, societal norms, and the public interest. Managed by students, JoinU trains the next generation of product managers to make socially responsible decisions. It serves as a practical training ground for making informed technology design and business decisions that benefit the public while ensuring sustainable growth.
        </motion.div>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 5 }}>
          Student Management at Harvard
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
        Students enrolled in the Tech Science Program in Government at Harvard College are responsible for managing Harvard's JoinU platform. Their hands-on involvement spans product management, marketing, and strategic decision-making. This practical experience equips them to lead future technology projects that not only serve the public interest but are also profitable and sustainable. JoinU for the Harvard community sets a precedent for the JoinU model, promoting its adaptation and implementation in other communities and educational settings.
        </motion.div>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 5 }}>
          Developed for the Public Good
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 5 }}>
          The website, app, and digital services of JoinU are the brainchild of {' '}
          <a href='https://techlab.org/' target='_blank' rel='noreferrer'>
            The Public Interest Tech Lab at Harvard University
          </a>
          , an organization dedicated to resolving conflicts between technology and society for the benefit of all. The Tech Lab provides ongoing critical infrastructures and professional support for all JoinU platforms, steadfastly committed to maintaining privacy, adhering to societal norms, and promoting the public interest. The team comprises, in alphabetical order:
        </motion.div>
        <List
          sx={{
            listStyleType: 'disc',
            pl: 2,
            '& .MuiListItem-root': {
              display: 'list-item',
              pt: 0,
              pb: 0,
              pr: 0,
            },
          }}
        >
          {[
            'Pascal Delpe-Brice',
            'Emine Dogan',
            'James Huettig',
            'Mamoun Janfor',
            'Eli Munn',
            'Jessica Shorland',
            'Latanya Sweeney',
            'Chibuikem Uche',
          ].map((d, i) => (
            <ListItem style={{ fontSize: 18, marginBottom: 5 }}>{d}</ListItem>
          ))}
        </List>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 5, marginTop: 30 }}>
          History of JoinU
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
          Learn more about the creation and history of JoinU{' '}
          <a href='https://joinu.org/history'>on the JoinU History page (joinu.org/history).</a>
        </motion.div>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 5, marginTop: 30 }}>
          Contact Us
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
          For more information, to get involved, or to implement a JoinU platform at your school or organization, you can reach us at{' '}
          <a href='mailto:contact@joinu.org'>contact@joinu.org</a>
          {' '} or visit{' '}
          <a href='https://joinu.org'>joinu.org</a>
          {' '} for more information.
        </motion.div>
      </Stack>
    </Stack>
  )
}
